<div class="rv-grid-large">
  <div class="grid-inner">
    <div class="rv-center column-small-12">
      <submit-error>
        <p>It appears you found a dead link:</p>
        <p>{{ url() }}</p>
        <a class="rv-link" (click)="back()">Go back</a>
        or
        <a
          routerLink="/accounts/{{ accountIdService.value }}/welcome"
          class="rv-link"
        >
          Go home
        </a>
      </submit-error>
    </div>
  </div>
</div>
